import { Stack } from '@chakra-ui/react';
import * as tp from '@main/shared/utils/timeperiod';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { TimeBoundary } from './time-boundary';

export type TimePeriodProps = {
  value?: tp.TimePeriod;
  onChange: (value: tp.TimePeriod) => void;
  isDisabled?: boolean;
};

const DEFAULT_TIME_PERIOD: tp.TimePeriod = {
  start: {
    type: tp.TimeBoundaryType.Now,
  },
  end: {
    type: tp.TimeBoundaryType.Now,
  },
};

export const TimePeriod = ({ value, onChange, isDisabled }: TimePeriodProps) => {
  const { t } = useTranslation('ui');
  // useRef to not put `onChange` in `useEffect` deps below
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    // Adjustment for react-hook-form: if the provided value is `undefined` or an empty object,
    // reset it to the default.
    if (!value || Object.keys(value).length === 0) {
      onChangeRef.current(DEFAULT_TIME_PERIOD);
    }
  }, [value]);

  const valueOrDefault = value ?? DEFAULT_TIME_PERIOD;

  return (
    <Stack>
      <TimeBoundary
        label={t('timePeriod.startLbl')}
        value={value?.start}
        onChange={(start) => {
          onChange({ ...valueOrDefault, start });
        }}
        isDisabled={isDisabled}
      />
      <TimeBoundary
        label={t('timePeriod.endLbl')}
        value={value?.end}
        onChange={(end) => {
          onChange({ ...valueOrDefault, end });
        }}
        isDisabled={isDisabled}
      />
    </Stack>
  );
};
